import { DateType } from "../../data/types/index";
import { dateFormat } from "../../utilities/parseHelper";
import { dateFilter } from "../../filters/date.filter";
import currencyFilter from "../../filters/currency.filter";
import { ScheduleStates } from "../../models/enums/scheduleStates";
import i18n from "@/i18n";

/** Общая модель операции для выписок и истории операций */
export class ScheduleItem {
  public TooltipEnable: boolean = false;

  /** Статус платежа */
  public State: ScheduleStates = 0;

  /** Дата платежа */
  public Date: string = "";

  /** Погашение процентов */
  public PercSum: number = 0;

  /** Погашение основного долга */
  public MainSum: number = 0;

  /** Пени и штрафы */
  public PenaltySum: number = 0;

  /** Платеж */
  public TotalSum: number = 0;

  /** Остаток */
  public MainRest: number = 0;

  /** Фактическая дата платежа */
  public FullRepaymentDate: string = "";

  public Currency: string = '';

  constructor(src: any, charCode: string = '') {
    if (charCode.length) {
      this.Currency = currencyFilter(charCode);
    }
    this.Date = dateFilter(src.Date, 'date') ??
      new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "-").split('-').reverse().join('.');
    this.FullRepaymentDate = dateFilter(src.FullRepaymentDate, 'date') ??
      new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "-").split('-').reverse().join('.');
    this.State = (src.State ?? 4) as ScheduleStates;
    this.PercSum = src.PercSum ?? 0;
    this.MainSum = src.MainSum ?? 0;
    this.PenaltySum = src.PenaltySum ?? 0;
    this.TotalSum = src.TotalSum ?? 0;
    this.MainRest = src.MainRest ?? 0;
  }

  public get stateText(): string {
    if (this.State === ScheduleStates.Success)
      return i18n.t("main.contracts.scheduleStates.success").toString();
    else if (this.State === ScheduleStates.Failed) {
      this.TooltipEnable = true;
      return i18n.t("main.contracts.scheduleStates.failed").toString();
    } else return "Ожидается";
  }
}
